import { render, staticRenderFns } from "./AnnounceModal.vue?vue&type=template&id=076edf53&scoped=true&"
import script from "./AnnounceModal.vue?vue&type=script&lang=ts&"
export * from "./AnnounceModal.vue?vue&type=script&lang=ts&"
import style0 from "./AnnounceModal.vue?vue&type=style&index=0&id=076edf53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076edf53",
  null
  
)

export default component.exports